export const SELECT_LOCATION = "SELECT_LOCATION";
export const SEARCH_LOCATION = "SEARCH_LOCATION";
export const SEARCH_LOCATION_CLEAR = "SEARCH_LOCATION_CLEAR";
export const CLEAR_LOCATIONS = "CLEAR_LOCATIONS";
export const CLEAR_LOCATIONS_RESULTS = "CLEAR_LOCATIONS_RESULTS";
export const SEARCH_LOCATION_SUCCESS = "SEARCH_LOCATION_SUCCESS";
export const SEARCH_LOCATION_ERROR = "SEARCH_LOCATION_ERROR";
export const GET_LOCATION_TYPES = "GET_LOCATION_TYPES";
export const GET_LOCATION_TYPES_SUCCESS = "GET_LOCATION_TYPES_SUCCESS";
export const GET_FACILITY_TYPES = "GET_FACILITYY_TYPES";
export const GET_FACILITY_TYPES_SUCCESS = "GET_FACILITY_TYPES_SUCCESS";

export const SEARCH_PROVIDER = "SEARCH_PROVIDER";
export const SEARCH_PROVIDER_CLEAR = "SEARCH_PROVIDER_CLEAR";
export const SEARCH_PROVIDER_ERROR = "SEARCH_PROVIDER_ERROR";
export const SEARCH_PROVIDER_BY_LOCAION = "SEARCH_PROVIDER_BY_LOCATION";
export const SEARCH_PROVIDER_BY_NAME = "SEARCH_PROVIDER_BY_NAME";
export const PROVIDER_DETAIL = "PROVIDER_DETAIL";
export const SELECT_PROVIDER = "SELECT_PROVIDER";
export const LOAD_PROVIDERS_SUCCESS = "LOAD_PROVIDERS_SUCCESS";
export const SAVE_PROVIDER_SEARCH_MODEL = "SAVE_PROVIDER_SEARCH_MODEL";
export const LOAD_PROVIDER_DETAIL_SUCCESS = "LOAD_PROVIDER_DETAIL_SUCCESS";
export const CLEAR_PROVIDERS = "CLEAR_PROVIDERS";
export const CLEAR_PROVIDER_DETAIL = "CLEAR_PROVIDER_DETAIL";
export const UPDATE_FACETS = "UPDATE_FACETS";
export const UPDATE_USEMYBSWHEALTH_FILTER = "UPDATE_USEMYBSWHEALTH_FILTER";
export const FIND_CARE_FILTERS_OPEN = "FIND_CARE_FILTERS_OPEN";

export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const APPLICATION_ERROR = "APPLICATION_ERROR";
export const INIT_SESSION = "INIT_SESSION";

export const NOTICES_NON_LOGGED_IN = "NOTICES_NON_LOGGED_IN";
export const NOTICES_LOGGED_IN = "NOTICES_LOGGED_IN";
export const NOTICES_NON_LOGGED_IN_HIDE = "NOTICES_NON_LOGGED_IN_HIDE";
export const NOTICES_LOGGED_IN_HIDE = "NOTICES_LOGGED_IN_HIDE";

export const USER_AUTHENTICATE = "USER_AUTHENTICATE";
export const USER_AUTHENTICATE_SUCCESS = "USER_AUTHENTICATE_SUCCESS";
export const USER_AUTHENTICATE_FAILURE = "USER_AUTHENTICATE_FAILURE";
export const USER_AUTHENTICATE_REFRESH = "USER_AUTHENTICATE_REFRESH";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOGOUT_COMPLETED = "LOGOUT_COMPLETED";
export const VERIFY_LOGIN = "VERIFY_LOGIN";
export const VERIFY_LOGIN_COMPLETED = "VERIFY_LOGIN_COMPLETED";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const CHECK_IS_LOGGED_IN = "CHECK_IS_LOGGED_IN";
export const LOGIN_FORM_SUCCESS = "LOGIN_FORM_SUCCESS";
export const CLEAR_USERLOGGEDOUT_MESSAGE = "CLEAR_USERLOGGEDOUT_MESSAGE";
export const CLEAR_LOGGEDOUT_MESSAGE = "CLEAR_LOGGEDOUT_MESSAGE";
export const CLEAR_REDIRECT_URL = "CLEAR_REDIRECT_URL";
export const SET_AD_USER_DATA = "SET_AD_USER_DATA";
export const SET_AD_ID_TOKEN = "SET_AD_ID_TOKEN";
export const SET_HEALTH_SOURCE_TOKEN = "SET_HEALTH_SOURCE_TOKEN";


export const PROXY_LIST_LOADING = "PROXY_LIST_LOADING";
export const PROXY_LIST_LOADED = "PROXY_LIST_LOADED";
export const NO_USER_PROXY = "NO_USER_PROXY";
export const PROXY_LIST_FAILURE = "PROXY_LIST_FAILURE";
export const USER_TO_SWITCH = "USER_TO_SWITCH";
export const SWITCH_USER_SAGA = "SWITCH_USER_SAGA";
export const SWITCH_USER_REDUCER = "SWITCH_USER_REDUCER";
export const SWITCH_TO_PHARMACY_USER = "SWITCH_TO_PHARMACY_USER";
export const RESET_USER_VALUE = "RESET_USER_VALUE";

export const LOAD_DASHBOARD_START = "LOAD_DASHBOARD_START";
export const LOAD_DASHBOARD_SUCCESS = "LOAD_DASHBOARD_SUCCESS";
export const LOAD_DASHBOARD_ERROR = "LOAD_DASHBOARD_ERROR";
export const TODOS_SUCCESS = "TODOS_SUCCESS";
export const TODOS_FAILURE = "TODOS_FAILURE";

export const LOAD_HEALTHPLANDASHBOARD_START = "LOAD_HEALTHPLANDASHBOARD_START";
export const LOAD_HEALTHPLANDASHBOARD_SUCCESS = "LOAD_HEALTHPLANDASHBOARD_SUCCESS";

export const THRIVE = "THRIVE";
export const EVISIT = "EVISIT";

export const LOAD_HEALTHSOURCEDASHBOARD_START = "LOAD_HEALTHSOURCEDASHBOARD_START";
export const LOAD_HEALTHSOURCEDASHBOARD_SUCCESS = "LOAD_HEALTHSOURCEDASHBOARD_SUCCESS";
export const REMOVE_SLIDE = "REMOVE_SLIDE";

export const LOAD_PHARMACYDASHBOARD_START = "LOAD_PHARMACYDASHBOARD_START";
export const LOAD_PHARMACYDASHBOARD_SUCCESS = "LOAD_PHARMACYDASHBOARD_SUCCESS";
export const LOAD_PHARMACYDASHBOARD_FAILURE = "LOAD_PHARMACYDASHBOARD_FAILURE";
export const GEOLOCATION = "GEOLOCATION";
export const GEOADDRESS = "GEOADDRESS";
export const GEOLOCATION_SUCCESS = "GEOLOCATION_SUCCESS";
export const GEOLOCATION_FAILURE = "GEOLOCATION_FAILURE";
export const GEOADDRESS_SUCCESS = "GEOADDRESS_SUCCESS";
export const GEOADDRESS_FAILURE = "GEOADDRESS_FAILURE";
export const CLOSEST_PHARMACY = "CLOSEST_PHARMACY";
export const CLOSEST_PHARMACY_SUCCESS = "CLOSEST_PHARMACY_SUCCESS";
export const CLOSEST_PHARMACY_FAILURE = "CLOSEST_PHARMACY_FAILURE";
export const LINK_PHARMACY_DIALOG_OPEN = "LINK_PHARMACY_DIALOG_OPEN";
export const LINK_PHARMACY_DIALOG_CLOSE = "LINK_PHARMACY_DIALOG_CLOSE";
export const LINK_PHARMACY = "LINK_PHARMACY";
export const LINK_PHARMACY_SUCCESS = "LINK_PHARMACY_SUCCESS";
export const LINK_PHARMACY_FAILURE = "LINK_PHARMACY_FAILURE";

export const RX_READY_FOR_PICKUP = "RX_READY_FOR_PICKUP";
export const RX_READY_FOR_PICKUP_SUCCESS = "RX_READY_FOR_PICKUP_SUCCESS";
export const RX_READY_FOR_PICKUP_FAILURE = "RX_READY_FOR_PICKUP_FAILURE";
export const RX_READY_FOR_REFILL_SUCCESS = "RX_READY_FOR_REFILL_SUCCESS";
export const RX_READY_FOR_REFILL_FAILURE = "RX_READY_FOR_REFILL_FAILURE";
export const RXTRANSFER_START = "RXTRANSFER_START";
export const EXTERNAL_RX_TRANSFER_START = "EXTERNAL_RX_TRANSFER_START";
export const EXTERNAL_RX_TRANSFER_SUCCESS = "EXTERNAL_RX_TRANSFER_SUCCESS";
export const EXTERNAL_RX_TRANSFER_FAILURE = "EXTERNAL_RX_TRANSFER_FAILURE";
export const PHARMACY_LIST_START = "PHARMACY_LIST_START";
export const PHARMACY_LIST_COMPLETED = "PHARMACY_LIST_COMPLETED";
export const RECENTPHARMACY_LIST_START = "RECENTPHARMACY_LIST_START";
export const RECENTPHARMACY_LIST_COMPLETED = "RECENTPHARMACY_LIST_COMPLETED";

export const LOAD_RX_LIST_START = "LOAD_RX_LIST_START";
export const LOAD_RX_LIST_COMPLETED = "LOAD_RX_LIST_COMPLETED";
export const RX_List_FAILURE = "RX_List_FAILURE";

export const LOAD_ARCHIVED_RX_LIST_START = "LOAD_ARCHIVED_RX_LIST_START";
export const ARCHIVE_UNARCHIVE_RX_START = "ARCHIVE_UNARCHIVE_RX_START";
export const ARCHIVE_UNARCHIVE_RX_SUCCESS = "ARCHIVE_UNARCHIVE_RX_SUCCESS";
export const ARCHIVE_UNARCHIVE_RX_FAILURE = "ARCHIVE_UNARCHIVE_RX_FAILURE";
export const LOAD_ARCHIVED_RX_LIST_COMPLETED = "LOAD_ARCHIVED_RX_LIST_COMPLETED";
export const RX_ARCHIVED_List_FAILURE = "RX_ARCHIVED_List_FAILURE";

export const RX_DETAIL = "RX_DETAIL";
export const RX_DETAIL_SUCCESS = "RX_DETAIL_SUCCESS";
export const RX_DETAIL_FAILURE = "RX_DETAIL_FAILURE";
export const RX_HISTORY = "RX_HISTORY";
export const RX_HISTORY_SUCCESS = "RX_HISTORY_SUCCESS";
export const RX_HISTORY_FAILURE = "RX_HISTORY_FAILURE";

export const UNLINK_RX_TRANSFER_START = "UNLINK_RX_TRANSFER_START";
export const UNLINK_RX_TRANSFER_SUCCESS = "UNLINK_RX_TRANSFER_SUCCESS";

export const SET_SERVER_DATA = "SET_SERVER_DATA";
export const SET_HISTORY_OBJECT = "SET_HISTORY_OBJECT";
export const UPDATE_PATIENT_IDS = "UPDATE_PATIENT_IDS";

export const LOAD_ORDERREFILLS_LIST_START = "LOAD_ORDERREFILLS_LIST_START";
export const LOAD_ORDERREFILLS_LIST_COMPLETED = "LOAD_ORDERREFILLS_LIST_COMPLETED";
export const LOAD_ORDERREFILLS_LIST_FAILURE = "LOAD_ORDERREFILLS_LIST_FAILURE";
export const ORDER_REFILL_LIST_UPDATE = "ORDER_REFILL_LIST_UPDATE";

export const LOAD_PICKUP_HOURS_START = "LOAD_PICKUP_HOURS_START";
export const LOAD_PICKUP_HOURS_COMPLETED = "LOAD_PICKUP_HOURS_COMPLETED";

export const SUBMIT_IVR_START = "SUBMIT_IVR_START";
export const SUBMIT_IVR_ORDER_REQUEST = "SUBMIT_IVR_ORDER_REQUEST";
export const SUBMIT_IVR_ORDER_COMPLETED = "SUBMIT_IVR_ORDER_COMPLETED";

export const INTERNAL_RX_TRANSFER_START = "INTERNAL_RX_TRANSFER_START";
export const INTERNAL_RX_TRANSFER_COMPLETED = "INTERNAL_RX_TRANSFER_COMPLETED";
export const INTERNAL_RX_TRANSFER_FAILURE = "INTERNAL_RX_TRANSFER_FAILURE";

export const GET_PHARMACY_BY_STORENUMBER_START = "GET_PHARMACY_BY_STORENUMBER_START";
export const GET_PHARMACY_BY_STORENUMBER_COMPLETED = "GET_PHARMACY_BY_STORENUMBER_COMPLETED";


export const MAP__CLOSE_INFO_WINDOW = "MAP__CLOSE_INFO_WINDOW";

export const MAP__OPEN_MODAL_WINDOW = "MAP__OPEN_MODAL_WINDOW";

export const MAP__CLOSE_MODAL_WINDOW = "MAP__CLOSE_MODAL_WINDOW";

export const SET_FAVOURITE_PHARMACY_START = "SET_FAVOURITE_PHARMACY_START";
export const SET_FAVOURITE_PHARMACY_SUCCESS = "SET_FAVOURITE_PHARMACY_SUCCESS";

export const OPEN_SCHEDULE_PROVIDER = "OPEN_SCHEDULE_PROVIDER";
export const OPEN_SCHEDULE_PROVIDER_SUCCESS = "OPEN_SCHEDULE_PROVIDER_SUCCESS";
export const OPEN_SCHEDULE_PROVIDER_FAILED = "OPEN_SCHEDULE_PROVIDER_FAILED";
export const OPEN_SCHEDULE_PROV_LOC = "OPEN_SCHEDULE_PROV_LOC";
export const OPEN_SCHEDULE_PROV_LOC_SUCCESS = "OPEN_SCHEDULE_PROV_LOC_SUCCESS";
export const OPEN_SCHEDULE_AVAILABILITY = "OPEN_SCHEDULE_AVAILABILITY";
export const OPEN_SCHEDULE_AVAILABILITY_SUCCESS = "OPEN_SCHEDULE_AVAILABILITY_SUCCESS";
export const OPEN_SCHEDULE_SCHEDULE = "OPEN_SCHEDULE_SCHEDULE";
export const OPEN_SCHEDULE_SCHEDULE_SUCCESS = "OPEN_SCHEDULE_SCHEDULE_SUCCESS";
export const OPEN_SCHEDULE_SCHEDULE_FAILED = "OPEN_SCHEDULE_SCHEDULE_FAILED";
export const OPEN_SCHEDULE_SCHEDULE_PENDING = "OPEN_SCHEDULE_SCHEDULE_PENDING";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_RUNNING";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_SUCCESS";
export const OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED = "OPEN_SCHEDULE_VISIT_TYPE_LOCATION_FAILED";
export const OPEN_SCHEDULE_EARLIEST = "OPEN_SCHEDULE_EARLIEST";
export const OPEN_SCHEDULE_EARLIEST_SUCCESS = "OPEN_SCHEDULE_EARLIEST_SUCCESS";
export const OPEN_SCHEDULE_PROVIDER_LIST = "OPEN_SCHEDULE_PROVIDER_LIST";
export const OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS = "OPEN_SCHEDULE_PROVIDER_LIST_SUCCESS";
export const OPEN_SCHEDULE_CREATE_PATIENT = "OPEN_SCHEDULE_CREATE_PATIENT";
export const OPEN_SCHEDULE_CREATE_AND_SCHEDULE = "OPEN_SCHEDULE_CREATE_AND_SCHEDULE";
export const OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS = "OPEN_SCHEDULE_CREATE_PATIENT_SUCCESS";
export const OPEN_SCHEDULE_CREATE_PATIENT_FAILED = "OPEN_SCHEDULE_CREATE_PATIENT_FAILED";
export const OPEN_SCHEDULE_CLEAR_REDUX_STATE = "OPEN_SCHEDULE_CLEAR_REDUX_STATE";
export const RESET_SELECTED_MAPS_VALUE = "RESET_SELECTED_MAPS_VALUE";
export const CURRENT_LOCATION_ZIPCODE = "CURRENT_LOCATION_ZIPCODE";

export const CHANGE_USERNAME = "CHANGE_USERNAME";
export const CHANGE_USERNAME_SUCCESS = "CHANGE_USERNAME_SUCCESS";
export const CHANGE_USERNAME_FAILURE = "CHANGE_USERNAME_FAILURE";
export const CHANGE_USERNAME_CLEAR = "CHANGE_USERNAME_CLEAR";

export const CHANGE_EMAIL_START = "CHANGE_EMAIL_START";
export const CHANGE_EMAIL_SUCCESS = "CHANGE_EMAIL_SUCCESS";
export const CHANGE_EMAIL_FAILURE = "CHANGE_EMAIL_FAILURE";
export const CHANGE_EMAIL_CLEAR_MESSAGE = "CHANGE_EMAIL_CLEAR_MESSAGE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const CHANGE_PASSWORD_CLEAR = "CHANGE_PASSWORD_CLEAR";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_CLEAR = "FORGOT_PASSWORD_CLEAR";

export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const LINK_EMPLOYEE_ACCOUNT_START = "LINK_EMPLOYEE_ACCOUNT_START";
export const LINK_EMPLOYEE_ACCOUNT_SUCCESS = "LINK_EMPLOYEE_ACCOUNT_SUCCESS";
export const LINK_EMPLOYEE_ACCOUNT_FAILURE = "LINK_EMPLOYEE_ACCOUNT_FAILURE";
export const LINK_EMPLOYEE_CLEAR_MESSAGE = "LINK_EMPLOYEE_CLEAR_MESSAGE";

export const UNLINK_EMPLOYEE_ACCOUNT_START = "UNLINK_EMPLOYEE_ACCOUNT_START";
export const UNLINK_EMPLOYEE_ACCOUNT_SUCCESS = "UNLINK_EMPLOYEE_ACCOUNT_SUCCESS";
export const UNLINK_EMPLOYEE_ACCOUNT_FAILURE = "UNLINK_EMPLOYEE_ACCOUNT_FAILURE";
export const UNLINK_EMPLOYEE_CLEAR_MESSAGE = "UNLINK_EMPLOYEE_CLEAR_MESSAGE";

export const LINK_MYCHART_ACCOUNT_START = "LINK_MYCHART_ACCOUNT_START";
export const LINK_MYCHART_ACCOUNT_SUCCESS = "LINK_MYCHART_ACCOUNT_SUCCESS";
export const LINK_MYCHART_ACCOUNT_FAILURE = "LINK_MYCHART_ACCOUNT_FAILURE";
export const LINK_MYCHART_CLEAR_MESSAGE = "LINK_MYCHART_CLEAR_MESSAGE";

export const UNLINK_MYCHART_ACCOUNT_START = "UNLINK_MYCHART_ACCOUNT_START";
export const UNLINK_MYCHART_ACCOUNT_SUCCESS = "UNLINK_MYCHART_ACCOUNT_SUCCESS";
export const UNLINK_MYCHART_ACCOUNT_FAILURE = "UNLINK_MYCHART_ACCOUNT_FAILURE";
export const UNLINK_MYCHART_CLEAR_MESSAGE = "UNLINK_MYCHART_CLEAR_MESSAGE";

export const LINK_HEALTHPLAN_ACCOUNT_START = "LINK_HEALTHPLAN_ACCOUNT_START";
export const LINK_HEALTHPLAN_ACCOUNT_SUCCESS = "LINK_HEALTHPLAN_ACCOUNT_SUCCESS";
export const LINK_HEALTHPLAN_ACCOUNT_FAILURE = "LINK_HEALTHPLAN_ACCOUNT_FAILURE";
export const LINK_HEALTHPLAN_CLEAR_MESSAGE = "LINK_HEALTHPLAN_CLEAR_MESSAGE";

export const UNLINK_HEALTHPLAN_ACCOUNT_START = "UNLINK_HEALTHPLAN_ACCOUNT_START";
export const UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS = "UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS";
export const UNLINK_HEALTHPLAN_ACCOUNT_FAILURE = "UNLINK_HEALTHPLAN_ACCOUNT_FAILURE";
export const UNLINK_HEALTHPLAN_CLEAR_MESSAGE = "UNLINK_HEALTHPLAN_CLEAR_MESSAGE";

export const RX_DEFAULT_PHARMACY_FAILURE = "RX_DEFAULT_PHARMACY_FAILURE";
export const GET_PHARMACY_BY_STORENUMBER_FAILURE = "GET_PHARMACY_BY_STORENUMBER_FAILURE";
export const SUBMIT_IVR_ORDER_FAILURE = "SUBMIT_IVR_ORDER_FAILURE";
export const LOAD_PICKUP_HOURS_FAILURE = "LOAD_PICKUP_HOURS_FAILURE";
export const UNLINK_RX_TRANSFER_FAILURE = "UNLINK_RX_TRANSFER_FAILURE";
export const RECENTPHARMACY_LIST_FAILURE = "RECENTPHARMACY_LIST_FAILURE";
export const CITY_ZIP_LIST = "CITY_ZIP_LIST";
export const CITY_ZIP_LIST_SUCCESS = "CITY_ZIP_LIST_SUCCESS";
export const CITY_ZIP_LIST_FAILURE = "CITY_ZIP_LIST_FAILURE";
export const CITIES_LIST_FAILURE = "CITIES_LIST_FAILURE";
export const RXTRANSFER_FAILURE = "RXTRANSFER_FAILURE";
export const SET_FAVOURITE_PHARMACY_FAILURE = "SET_FAVOURITE_PHARMACY_FAILURE";

export const SET_PROGRESS_FORWARD = "SET_PROGRESS_FORWARD";
export const RESET_LOGIN_SETTINGS_DATA = "RESET_LOGIN_SETTINGS_DATA";

export const ARCHIVE_UNLINKED_RX_TRANSFER_START = "ARCHIVE_UNLINKED_RX_TRANSFER_START";
export const ARCHIVE_UNLINKED_RX_TRANSFER_SUCCESS = "ARCHIVE_UNLINKED_RX_TRANSFER_SUCCESS";
export const ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE = "ARCHIVE_UNLINKED_RX_TRANSFER_FAILURE";

export const GET_FAVORITE_PROVIDERS_START = "GET_FAVORITE_PROVIDERS_START";
export const GET_FAVORITE_PROVIDERS_SUCCESS = "GET_FAVORITE_PROVIDERS_SUCCESS";
export const GET_FAVORITE_PROVIDERS_FAILURE = "GET_FAVORITE_PROVIDERS_FAILURE";

export const FORGOT_USERNAME_START = "FORGOT_USERNAME_START";
export const FORGOT_USERNAME_SUCCESS = "FORGOT_USERNAME_SUCCESS";
export const FORGOT_USERNAME_FAILURE = "FORGOT_USERNAME_FAILURE";
export const FORGOT_USERNAME_CLEAR = "FORGOT_USERNAME_CLEAR";

export const LOAD_DOCS_DATA = "LOAD_DOCS_DATA";
export const LOAD_DOCS_DATA_SUCCESS = "LOAD_DOCS_DATA_SUCCESS";
export const LOAD_DOCS_DATA_FAILURE = "LOAD_DOCS_DATA_FAILURE";

export const REMOVE_FAVORITE_PROVIDER_START = "REMOVE_FAVORITE_PROVIDER_START";
export const REMOVE_FAVORITE_PROVIDER_SUCCESS = "REMOVE_FAVORITE_PROVIDER_SUCCESS";
export const REMOVE_FAVORITE_PROVIDER_FAILURE = "REMOVE_FAVORITE_PROVIDER_FAILURE";

export const ADD_FAVORITE_PROVIDER_START = "ADD_FAVORITE_PROVIDER_START";
export const ADD_FAVORITE_PROVIDER_SUCCESS = "ADD_FAVORITE_PROVIDER_SUCCESS";
export const ADD_FAVORITE_PROVIDER_FAILURE = "ADD_FAVORITE_PROVIDER_FAILURE";

export const LOAD_MYCHART_TERMS_DATA_START = "LOAD_MYCHART_TERMS_DATA_START";
export const LOAD_MYCHART_TERMS_DATA_SUCCESS = "LOAD_MYCHART_TERMS_DATA_SUCCESS";
export const LOAD_MYCHART_TERMS_DATA_FAILURE = "LOAD_MYCHART_TERMS_DATA_FAILURE";

export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";
export const LOAD_TERMS_AND_CONDITIONS = "LOAD_TERMS_AND_CONDITIONS";
export const ACCEPT_TERMS_AND_CONDITIONS = "ACCEPT_TERMS_AND_CONDITIONS";

export const PHARMACY_PROXY_INFO = "pharmacyProxyInfo";
export const PHARMACY_PROXY_REQUEST = "pharmacyProxyRequest";
export const PHARMACY_PROXY_REQUEST_DATA = "pharmacyProxyRequestData";
export const PHARMACY_PROXY_RESEND_REQUEST = "pharmacyProxyResendRequest";
export const PHARMACY_PROXY_REMOVE = "pharmacyProxyRemove";
export const PHARMACY_PROXY_APPROVE = "pharmacyProxyApprove";
export const PHARMACY_PROXY_DECLINE = "pharmacyProxyDecline";
export const PHARMACY_PROXY_ACCESS_LIST = "pharmacyProxyAccessList";
export const PHARMACY_PROXY_GRANT = "pharmacyProxyGrant";
export const HEALTH_RECORD_PROXY_REQUEST = "healthRecordProxyRequest";
export const PROXY_REQUEST_DATA = "hrp_proxyRequestData";

export const MYCHART_PROXY_REQUEST = "mychartProxyRequest";

export const PHARMACY_NOTIFICATION_PREFERENCE_SAVE = "pharmacyNotificationPreferenceSave";

export const GET_CARETEAM_PROVIDERS_START = "GET_CARETEAM_PROVIDERS_START";
export const GET_CARETEAM_PROVIDERS_SUCCESS = "GET_CARETEAM_PROVIDERS_SUCCESS";
export const GET_CARETEAM_PROVIDERS_FAILURE = "GET_CARETEAM_PROVIDERS_FAILURE";

export const SET_PROVIDER_DETAILS_NPI_LISTS = "SET_PROVIDER_DETAILS_NPI_LISTS";
export const SET_PROVIDER_DETAILS_FROM_NPI_LIST = "SET_PROVIDER_DETAILS_FROM_NPI_LIST";
export const SET_PARSED_PROVIDER_DETAILS_LISTS = "SET_PARSED_PROVIDER_DETAILS_LISTS";

export const GET_USER_PHONE_NUMBER_START = "GET_USER_PHONE_NUMBER_START";
export const GET_USER_PHONE_NUMBER_SUCCESS = "GET_USER_PHONE_NUMBER_SUCCESS";
export const GET_USER_PHONE_NUMBER_FAILURE = "GET_USER_PHONE_NUMBER_FAILURE";

export const ADD_OR_UPDATE_USER_PHONE_NUMBER_START = "ADD_OR_UPDATE_USER_PHONE_NUMBER_START";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS = "ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE = "ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE";

export const GET_USER_ADDRESS_START = "GET_USER_ADDRESS_START";
export const GET_USER_ADDRESS_SUCCESS = "GET_USER_ADDRESS_SUCCESS";
export const GET_USER_ADDRESS_FAILURE = "GET_USER_ADDRESS_FAILURE";

export const GET_LAT_LNG_USER_ADDRESS_START = "GET_LAT_LNG_USER_ADDRESS_START";
export const GET_LAT_LNG_USER_ADDRESS_SUCCESS = "GET_LAT_LNG_USER_ADDRESS_SUCCESS";
export const GET_LAT_LNG_USER_ADDRESS_FAILURE = "GET_LAT_LNG_USER_ADDRESS_FAILURE";

export const RELOAD_KEY = "RELOAD_KEY";

export const SET_HIDE_TUTORIAL = "SET_HIDE_TUTORIAL";
export const SAVE_HIDE_TUTORIAL = "SAVE_HIDE_TUTORIAL";

export const SUBMIT_USER_FEEDBACK_FORM = "SUBMIT_USER_FEEDBACK_FORM";

export const DIRECT_SCHEDULING_PROVIDER_LIST = "DIRECT_SCHEDULING_PROVIDER_LIST";
export const DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS = "DIRECT_SCHEDULING_PROVIDER_LIST_SUCCESS";
export const DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE = "DIRECT_SCHEDULING_PROVIDER_LIST_FAILURE";

export const CONSENT_GET_FLU = "CONSENT_GET_FLU";
export const CONSENT_GET_SUCCESS = "CONSENT_GET_SUCCESS";
export const CONSENT_GET_FAILURE = "CONSENT_GET_FAILURE";
export const CONSENT_GET_PENDING = "CONSENT_GET_PENDING";
export const CONSENT_GET_LIST = "CONSENT_GET_LIST";
export const CONSENT_GET_LIST_SUCCESS = "CONSENT_GET_LIST_SUCCESS";
export const CONSENT_GET_LIST_FAILURE = "CONSENT_GET_LIST_FAILURE";

export const CONSENT_FLU_PENDING = "CONSENT_FLU_PENDING";
export const CONSENT_FLU_SUCCESS = "CONSENT_FLU_SUCCESS";
export const CONSENT_FLU_FAILURE = "CONSENT_FLU_FAILURE";

export const CONSENT_SET_FLU = "CONSENT_SET_FLU";
export const CONSENT_SET_SUCCESS = "CONSENT_SET_SUCCESS";
export const CONSENT_SET_FAILURE = "CONSENT_SET_FAILURE";
export const CONSENT_SET_PENDING = "CONSENT_SET_PENDING";

export const CONSENT_TYPE_GET = "CONSENT_TYPE_GET";
export const CONSENT_TYPE_PENDING = "CONSENT_TYPE_PENDING";
export const CONSENT_TYPE_SUCCESS = "CONSENT_TYPE_SUCCESS";
export const CONSENT_TYPE_FAILURE = "CONSENT_TYPE_FAILURE";

export const CONSENT_TYPE_LIST_GET = "CONSENT_TYPE_LIST_GET";
export const CONSENT_TYPE_LIST_PENDING = "CONSENT_TYPE_LIST_PENDING";
export const CONSENT_TYPE_LIST_SUCCESS = "CONSENT_TYPE_LIST_SUCCESS";
export const CONSENT_TYPE_LIST_FAILURE = "CONSENT_TYPE_LIST_FAILURE";

export const GET_EPIC_FLU_RECORD = "GET_EPIC_FLU_RECORD";
export const GET_EPIC_FLU_RECORD_PENDING = "GET_EPIC_FLU_RECORD_PENDING";
export const GET_EPIC_FLU_RECORD_SUCCESS = "GET_EPIC_FLU_RECORD_SUCCESS";
export const GET_EPIC_FLU_RECORD_FAILURE = "GET_EPIC_FLU_RECORD_FAILURE";

export const GET_PEOPLESOFT_FLU_RECORD = "GET_PEOPLE_PLACE_FLU_RECORD";
export const GET_PEOPLESOFT_FLU_RECORD_PENDING = "GET_PEOPLE_PLACE_FLU_RECORD_PENDING";
export const GET_PEOPLESOFT_FLU_RECORD_SUCCESS = "GET_PEOPLE_PLACE_FLU_RECORD_SUCCESS";
export const GET_PEOPLESOFT_FLU_RECORD_FAILURE = "GET_PEOPLE_PLACE_FLU_RECORD_SUCCESS";

export const GET_COMPLETE_FLU_STATUS = "GET_COMPLETE_FLU_STATUS";
export const GET_COMPLETE_FLU_STATUS_PENDING = "GET_COMPLETE_FLU_STATUS_PENDING";
export const GET_COMPLETE_FLU_STATUS_SUCCESS = "GET_COMPLETE_FLU_STATUS_SUCCESS";
export const GET_COMPLETE_FLU_STATUS_FAILURE = "GET_COMPLETE_FLU_STATUS_FAILURE";

export const EXPORT_FLU_EPIC_TO_PS = "EXPORT_FLU_EPIC_TO_PS";
export const EXPORT_FLU_EPIC_TO_PS_PENDING = "EXPORT_FLU_EPIC_TO_PS_PENDING";
export const EXPORT_FLU_EPIC_TO_PS_SUCCESS = "EXPORT_FLU_EPIC_TO_PS_SUCCESS";
export const EXPORT_FLU_EPIC_TO_PS_FAILURE = "EXPORT_FLU_EPIC_TO_PS_FAILURE";

export const DISABLE_FLU = "DISABLE_FLU";

export const STAY_ON_INCOMPLETE_FORM = "STAY_ON_INCOMPLETE_FORM";


export const SITE_SEARCH_START = "SITE_SEARCH_START";
export const SITE_SEARCH_SUCCESS = "SITE_SEARCH_SUCCESS";
export const SITE_SEARCH_FAILURE = "SITE_SEARCH_FAILURE";

export const PATIENT_PHOTO_START = "PATIENT_PHOTO_START";
export const PATIENT_PHOTO_SUCCESS = "PATIENT_PHOTO_SUCCESS";
export const PATIENT_PHOTO_FAILURE = "PATIENT_PHOTO_FAILURE";

export const PATIENT_DEMOGRAPHICS_START = "PATIENT_DEMOGRAPHICS_START";
export const PATIENT_DEMOGRAPHICS_SUCCESS = "PATIENT_DEMOGRAPHICS_SUCCESS";
export const PATIENT_DEMOGRAPHICS_FAILURE = "PATIENT_DEMOGRAPHICS_FAILURE";

export const THRIVE_GET_CARD = "THRIVE_GET_CARD";
export const THRIVE_GET_CARD_SUCCESS = "THRIVE_GET_CARD_SUCCESS";
export const THRIVE_GET_CARD_PENDING = "THRIVE_GET_CARD_PENDING";
export const THRIVE_GET_CARD_FAILURE = "THRIVE_GET_CARD_FAILURE";

export const THRIVE_GET_REPORT = "THRIVE_GET_REPORT";
export const THRIVE_GET_REPORT_SUCCESS = "THRIVE_GET_REPORT_SUCCESS";
export const THRIVE_GET_REPORT_PENDING = "THRIVE_GET_REPORT_PENDING";
export const THRIVE_GET_REPORT_FAILURE = "THRIVE_GET_REPORT_FAILURE";

export const HP_GET_ACCUMULATOR_DATA = "HP_GET_ACCUMULATOR_DATA";
export const HP_GET_ACCUMULATOR_DATA_START = "HP_GET_ACCUMULATOR_DATA_START";
export const HP_GET_ACCUMULATOR_DATA_SUCCESS = "HP_GET_ACCUMULATOR_DATA_SUCCESS";
export const HP_GET_ACCUMULATOR_DATA_FAILURE = "HP_GET_ACCUMULATOR_DATA_FAILURE";

export const HP_GET_CLAIMS_LIST = "HP_GET_CLAIMS_LIST";
export const HP_GET_CLAIMS_LIST_START = "HP_GET_CLAIMS_LIST_START";
export const HP_GET_CLAIMS_LIST_SUCCESS = "HP_GET_CLAIMS_LIST_SUCCESS";
export const HP_GET_CLAIMS_LIST_FAILURE = "HP_GET_CLAIMS_LIST_FAILURE";

export const HP_GET_CLAIM_DETAIL = "HP_GET_CLAIM_DETAIL";
export const HP_GET_CLAIM_DETAIL_START = "HP_GET_CLAIM_DETAIL_START";
export const HP_GET_CLAIM_DETAIL_SUCCESS = "HP_GET_CLAIM_DETAIL_SUCCESS";
export const HP_GET_CLAIM_DETAIL_FAILURE = "HP_GET_CLAIM_DETAIL_FAILURE";

export const HP_GET_IDCARD = "HP_GET_IDCARD";
export const HP_GET_IDCARD_START = "HP_GET_IDCARD_START";
export const HP_GET_IDCARD_SUCCESS = "HP_GET_IDCARD_SUCCESS";
export const HP_GET_IDCARD_FAILURE = "HP_GET_IDCARD_FAILURE";

export const HP_GET_MEMBERS_LIST = "HP_GET_MEMBERS_LIST";
export const HP_GET_MEMBERS_LIST_START = "HP_GET_MEMBERS_LIST_START";
export const HP_GET_MEMBERS_LIST_SUCCESS = "HP_GET_MEMBERS_LIST_SUCCESS";
export const HP_GET_MEMBERS_LIST_FAILURE = "HP_GET_MEMBERS_LIST_FAILURE";

export const HP_GET_PLAN_DETAIL = "HP_GET_PLAN_DETAIL";
export const HP_GET_PLAN_DETAIL_START = "HP_GET_PLAN_DETAIL_START";
export const HP_GET_PLAN_DETAIL_SUCCESS = "HP_GET_PLAN_DETAIL_SUCCESS";
export const HP_GET_PLAN_DETAIL_FAILURE = "HP_GET_PLAN_DETAIL_FAILURE";

export const HP_GET_PROFILE = "HP_GET_PROFILE";
export const HP_GET_PROFILE_START = "HP_GET_PROFILE_START";
export const HP_GET_PROFILE_SUCCESS = "HP_GET_PROFILE_SUCCESS";
export const HP_GET_PROFILE_FAILURE = "HP_GET_PROFILE_FAILURE";

export const HP_GET_EOB_DOCUMENT = "HP_GET_EOB_DOCUMENT";
export const HP_GET_EOB_DOCUMENT_START = "HP_GET_EOB_DOCUMENT_START";
export const HP_GET_EOB_DOCUMENT_SUCCESS = "HP_GET_EOB_DOCUMENT_SUCCESS";
export const HP_GET_EOB_DOCUMENT_FAILURE = "HP_GET_EOB_DOCUMENT_FAILURE";

export const HP_REQUEST_NEW_IDCARD = "HP_REQUEST_NEW_IDCARD";
export const HP_REQUEST_NEW_IDCARD_START = "HP_REQUEST_NEW_IDCARD_START";
export const HP_REQUEST_NEW_IDCARD_SUCCESS = "HP_REQUEST_NEW_IDCARD_SUCCESS";
export const HP_REQUEST_NEW_IDCARD_FAILURE = "HP_REQUEST_NEW_IDCARD_FAILURE";

export const GET_APP_UPDATE = "GET_APP_UPDATE";
export const HIDE_NORMAL_APP_UPDATE = "HIDE_NORMAL_APP_UPDATE";

export const GRAPHIC_BANNER_UPDATE = "GRAPHIC_BANNER_UPDATE";

export const SET_HIDE_AUTOAAL_LINKMODAL = "SET_HIDE_AUTOAAL_LINKMODAL";

export const LOAD_AAL_DATA_START = "LOAD_AAL_DATA_START";
export const LOAD_AAL_DATA_SUCCESS = "LOAD_AAL_DATA_SUCCESS";
export const LOAD_AAL_DATA_FAILURE = "LOAD_AAL_DATA_FAILURE";

export const LINK_AA_ACCOUNT_START = "LINK_AA_ACCOUNT_START";
export const LINK_AUTO_AA_ACCOUNT_START = "LINK_AUTO_AA_ACCOUNT_START";
export const LINK_AA_ACCOUNT_SUCCESS = "LINK_AA_ACCOUNT_SUCCESS";
export const LINK_AA_ACCOUNT_FAILURE = "LINK_AA_ACCOUNT_FAILURE";
export const LINK_AA_ACCOUNT_CLEAR_MESSAGE = "LINK_AA_ACCOUNT_CLEAR_MESSAGE";
export const LINK_AA_ACCOUNT_ERROR_COUNT = "LINK_AA_ACCOUNT_ERROR_COUNT";
export const LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS = "LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS";

export const UNLINK_AA_ACCOUNT_START = "UNLINK_AA_ACCOUNT_START";
export const UNLINK_AA_ACCOUNT_SUCCESS = "UNLINK_AA_ACCOUNT_SUCCESS";
export const UNLINK_AA_ACCOUNT_FAILURE = "UNLINK_AA_ACCOUNT_FAILURE";
export const UNLINK_AA_ACCOUNT_CLEAR_MESSAGE = "UNLINK_AA_ACCOUNT_CLEAR_MESSAGE";
export const UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS = "UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS";

export const COOKIE_BSWPROXY_START = "COOKIE_BSWPROXY_START";
export const COOKIE_BSWPROXY_SUCCESS = "COOKIE_BSWPROXY_SUCCESS";

export const ZIPNOSIS_EVISIT_URL = "ZIPNOSIS_EVISIT_URL";
export const ZIPNOSIS_EVISIT_URL_SUCCESS = "ZIPNOSIS_EVISIT_URL_SUCCESS";
export const ZIPNOSIS_EVISIT_URL_FAILURE = "ZIPNOSIS_EVISIT_URL_FAILURE";
export const ZIPNOSIS_EVISIT_CLEAR = "ZIPNOSIS_EVISIT_CLEAR";

export const UPDATE_MENU = "UPDATE_MENU";
export const HIDE_BANNER_ON_CRASH = "HIDE_BANNER_ON_CRASH";

export const GET_EPIC_LETTERS = "GET_EPIC_LETTERS";
export const GET_EPIC_LETTERS_SUCCESS = "GET_EPIC_LETTERS_SUCCESS";
export const GET_EPIC_LETTERS_FAILURE = "GET_EPIC_LETTERS_FAILURE";

export const PROXY_RELATIONSHIP_TYPES = "PROXY_RELATIONSHIP_TYPES";
export const PROXY_RELATIONSHIP_TYPES_PENDING = "PROXY_RELATIONSHIP_TYPES_PENDING";
export const PROXY_RELATIONSHIP_TYPES_SUCCESS = "PROXY_RELATIONSHIP_TYPES_SUCCESS";
export const PROXY_RELATIONSHIP_TYPES_FAILURE = "PROXY_RELATIONSHIP_TYPES_FAILURE";

export const PROXY_RELATIONSHIP_SET = "PROXY_RELATIONSHIP_SET";
export const PROXY_RELATIONSHIP_SET_PENDING = "PROXY_RELATIONSHIP_SET_PENDING";
export const PROXY_RELATIONSHIP_SET_SUCCESS = "PROXY_RELATIONSHIP_SET_SUCCESS";
export const PROXY_RELATIONSHIP_SET_FAILURE = "PROXY_RELATIONSHIP_SET_FAILURE";

export const PROXY_RELATIONSHIP_ACCEPT = "PROXY_RELATIONSHIP_ACCEPT";
export const PROXY_RELATIONSHIP_ACCEPT_PENDING = "PROXY_RELATIONSHIP_ACCEPT_PENDING";
export const PROXY_RELATIONSHIP_ACCEPT_SUCCESS = "PROXY_RELATIONSHIP_ACCEPT_SUCCESS";
export const PROXY_RELATIONSHIP_ACCEPT_FAILURE = "PROXY_RELATIONSHIP_ACCEPT_FAILURE";

export const PROXY_RELATIONSHIP_GRANT = "PROXY_RELATIONSHIP_GRANT";
export const PROXY_RELATIONSHIP_GRANT_PENDING = "PROXY_RELATIONSHIP_GRANT_PENDING";
export const PROXY_RELATIONSHIP_GRANT_SUCCESS = "PROXY_RELATIONSHIP_GRANT_SUCCESS";
export const PROXY_RELATIONSHIP_GRANT_FAILURE = "PROXY_RELATIONSHIP_GRANT_FAILURE";

export const PROXY_RELATIONSHIP_DELETE = "PROXY_RELATIONSHIP_DELETE";
export const PROXY_RELATIONSHIP_DELETE_PENDING = "PROXY_RELATIONSHIP_DELETE_PENDING";
export const PROXY_RELATIONSHIP_DELETE_SUCCESS = "PROXY_RELATIONSHIP_DELETE_SUCCESS";
export const PROXY_RELATIONSHIP_DELETE_FAILURE = "PROXY_RELATIONSHIP_DELETE_FAILURE";

export const REFRESH_PROXY_LIST = "REFRESH_PROXY_LIST";

export const UPDATE_INSURANCE_PREFERENCE = "UPDATE_INSURANCE_PREFERENCE";
export const SHOW_INSURANCE_FORM = "SHOW_INSURANCE_FORM";


export const SHOW_AUTOLINK_MYCHART = "SHOW_AUTOLINK_MYCHART";
export const UPDATE_AUTOLINK_MYCHART_PREFERENCE = "UPDATE_AUTOLINK_MYCHART_PREFERENCE";

export const AUTOLINK_MYCHART = "AUTOLINK_MYCHART";
export const AUTOLINK_MYCHART_SUCCESS = "AUTOLINK_MYCHART_SUCCESS";
export const AUTOLINK_MYCHART_FAILURE = "AUTOLINK_MYCHART_FAILURE";
export const AUTOLINK_MYCHART_ERROR_COUNT = "AUTOLINK_MYCHART_ERROR_COUNT";
export const AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS = "AUTOLINK_MYCHART_UPDATE_TOKEN_SUCCESS";
export const AUTOLINK_MYCHART_CLEAR_MESSAGE = "AUTOLINK_MYCHART_CLEAR_MESSAGE";

export const LOAD_DASHBOARD_V2_SUCCESS = "LOAD_DASHBOARD_V2_SUCCESS";

export const INITIATE_PROXY_REQUEST = "INITIATE_PROXY_REQUEST";
export const INITIATE_PROXY_REQUEST_PENDING = "INITIATE_PROXY_REQUEST_PENDING";
export const INITIATE_PROXY_REQUEST_SUCCESS = "INITIATE_PROXY_REQUEST_SUCCESS";
export const INITIATE_PROXY_REQUEST_FAILURE = "INITIATE_PROXY_REQUEST_FAILURE";
export const INITIATE_BOTH_PROXY_REQUEST = "INITIATE_BOTH_PROXY_REQUEST";
export const CARE_COACH_NOTIFICATION_PREFERENCE_SAVE = "CARE_COACH_NOTIFICATION_PREFERENCE_SAVE";
export const GET_USER_NOTIFICATION_PREFERENCE = "GET_USER_NOTIFICATION_PREFERENCE";

export const SET_SCREEN_BREAKPOINT = "SET_SCREEN_BREAKPOINT";

export const SET_VIDEO_VISIT_TOASTR_MSG = "SET_VIDEO_VISIT_TOASTR_MSG";

export const START_TOKEN_EXCHANGE = "START_TOKEN_EXCHANGE";
export const END_TOKEN_EXCHANGE = "END_TOKEN_EXCHANGE";

export const POST_LOGIN_START = "POST_LOGIN_START";
export const SET_PHYND_DATA = "SET_PHYND_DATA";

export const EPIC_DEPT_LIST_GET_START = "EPIC_DEPT_LIST_GET_START";
export const EPIC_DEPT_LIST_SET_DATA = "EPIC_DEPT_LIST_SET_DATA";
export const EPIC_DEPT_LIST_GET_END = "EPIC_DEPT_LIST_GET_END";

export const EPIC_PROVIDER_APPOINTMENTS_GET_START = "EPIC_PROVIDER_APPOINTMENTS_GET_START";
export const EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE = "EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE";
export const EPIC_PROVIDER_APPOINTMENTS_SET_DATA = "EPIC_PROVIDER_APPOINTMENTS_SET_DATA";
export const EPIC_PROVIDER_APPOINTMENTS_GET_END = "EPIC_PROVIDER_APPOINTMENTS_GET_END";
export const SAME_DAY_CARE_APPOINTMENTS_GET_START = "SAME_DAY_CARE_APPOINTMENTS_GET_START";
export const SAME_DAY_CARE_APPOINTMENTS_GET_FAILURE = "SAME_DAY_CARE_APPOINTMENTS_GET_FAILURE";
export const SAME_DAY_CARE_APPOINTMENTS_SET_DATA = "SAME_DAY_CARE_APPOINTMENTS_SET_DATA";
export const SAME_DAY_CARE_APPOINTMENTS_GET_END = "SAME_DAY_CARE_APPOINTMENTS_GET_END";
export const APPOINTMENTS_REFRESH_DATA = "APPOINTMENTS_REFRESH_DATA";

export const APP_START = "APP_START";


export const INSTADOC_SET_TOKEN = "INSTADOC_SET_TOKEN";
export const INSTADOC_TOKEN_GET_START = "INSTADOC_TOKEN_GET_START";
export const INSTADOC_TOKEN_GET_END = "INSTADOC_TOKEN_GET_END";
export const INSTADOC_TOKEN_REFRESH = "INSTADOC_TOKEN_REFRESH";
export const INSTADOC_SET_EMPLOYEE = "INSTADOC_SET_EMPLOYEE";
export const INSTADOC_PROVIDER_INFO_START = "INSTADOC_PROVIDER_INFO_START";
export const INSTADOC_PROVIDER_INFO_SUCCESS = "INSTADOC_PROVIDER_INFO_SUCCESS";
export const INSTADOC_PROVIDER_INFO_FAILURE = "INSTADOC_PROVIDER_INFO_FAILURE";

export const INSTADOC_PROVIDERS_START = "INSTADOC_PROVIDERS_START";
export const INSTADOC_PROVIDERS_SUCCESS = "INSTADOC_PROVIDERS_SUCCESS";
export const INSTADOC_PROVIDERS_FAILURE = "INSTADOC_PROVIDERS_FAILURE";

export const SET_PROVIDER_EPIC_IDS = "SET_PROVIDER_EPIC_IDS";

export const POSTLOGIN_PROCESS_START = "POSTLOGIN_PROCESS_START";
export const POSTLOGIN_PROCESS_END = "POSTLOGIN_PROCESS_END";

export const ROOM_ENTER = "ROOM_ENTER";
export const ROOM_LEAVE = "ROOM_LEAVE";
export const ROOM_HEARTBEAT = "ROOM_HEARTBEAT";


export const SET_SAME_DAY_CARE_CHECKBOX = "SET_SAME_DAY_CARE_CHECKBOX";

export const GET_ROOM_STATUSES_SUCCESS = "GET_ROOM_STATUSES_SUCCESS";
export const GET_ROOM_STATUSES_FAILURE = "GET_ROOM_STATUSES_FAILURE";

export const GET_CONSUMER_JWT = "GET_CONSUMER_JWT";
export const GET_CONSUMER_JWT_PENDING = "GET_CONSUMER_JWT_PENDING";
export const GET_CONSUMER_JWT_SUCCESS = "GET_CONSUMER_JWT_SUCCESS";
export const GET_CONSUMER_JWT_FAILURE = "GET_CONSUMER_JWT_FAILURE";

export const GET_PROVIDER_JWT = "GET_PROVIDER_JWT";
export const GET_PROVIDER_JWT_PENDING = "GET_PROVIDER_JWT_PENDING";
export const GET_PROVIDER_JWT_SUCCESS = "GET_PROVIDER_JWT_SUCCESS";
export const GET_PROVIDER_JWT_FAILURE = "GET_PROVIDER_JWT_FAILURE";

export const COLLAPSE_MENU = "COLLAPSE_MENU";

export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE";

export const IS_MOBILE_NUMBER = "IS_MOBILE_NUMBER";

export const SMS_VIDEO_VISIT_LINK = "SMS_VIDEO_VISIT_LINK";
export const SMS_VIDEO_VISIT_LINK_SUCCESS = "SMS_VIDEO_VISIT_LINK_SUCCESS";
export const SMS_VIDEO_VISIT_LINK_FAILURE = "SMS_VIDEO_VISIT_LINK_FAILURE";

export const EMAIL_VIDEO_VISIT_LINK = "EMAIL_VIDEO_VISIT_LINK";
export const EMAIL_VIDEO_VISIT_LINK_SUCCESS = "EMAIL_VIDEO_VISIT_LINK_SUCCESS";
export const EMAIL_VIDEO_VISIT_LINK_FAILURE = "EMAIL_VIDEO_VISIT_LINK_FAILURE";

export const SMS_VIDEO_VISIT_LINK_FOR_GUEST = "SMS_VIDEO_VISIT_LINK_FOR_GUEST";
export const SMS_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS = "SMS_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const SMS_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE = "SMS_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE";

export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST";
export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE";

export const CANCEL_VIDEO_VISIT_LINK = "CANCEL_VIDEO_VISIT_LINK";
export const CANCEL_VIDEO_VISIT_LINK_SUCCESS = "CANCEL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const CANCEL_VIDEO_VISIT_LINK__FAILURE = "CANCEL_VIDEO_VISIT_LINK_FAILURE";

export const VIDEO_VISIT_SHARE_LINK_HISTORY = "VIDEO_VISIT_SHARE_LINK_HISTORY";
export const VIDEO_VISIT_SHARE_LINK_HISTORY_SUCCESS = "VIDEO_VISIT_SHARE_LINK_HISTORY_SUCCESS";
export const VIDEO_VISIT_SHARE_LINK_HISTORY_FAILURE = "VIDEO_VISIT_SHARE_LINK_HISTORY_FAILURE";

export const SIGNALR_INIT = "SIGNALR_INIT";
export const SIGNALR_UPDATE_ROOM = "SIGNALR_UPDATE_ROOM";

export const SYNC_ROOMS = "SYNC_ROOMS";

export const EMPLOYEE_TYPES = "EMPLOYEE_TYPES";
export const ROOM_STATUSES = "ROOM_STATUSES";

export const USER_SETTINGS = "USER_SETTINGS";

export const ADAL_TOKEN_REFRESH = "ADAL_TOKEN_REFRESH";
export const GUEST_LINK_APPROVAL_STATUS = "GUEST_LINK_APPROVAL_STATUS";
export const SET_GUEST_LINK_APPROVAL_STATUS = "SET_GUEST_LINK_APPROVAL_STATUS";
export const ALLOW_GUEST = "ALLOW_GUEST";
export const DENY_GUEST = "DENY_GUEST";

export const APPOINTMENT_HISTORY = "APPOINTMENT_HISTORY";
export const APPOINTMENT_HISTORY_PENDING = "APPOINTMENT_HISTORY_PENDING";
export const APPOINTMENT_HISTORY_SUCCESS = "APPOINTMENT_HISTORY_SUCCESS";

export const CREATE_VIRTUAL_ROOM = "CREATE_VIRTUAL_ROOM";
export const CREATE_VIRTUAL_ROOM_PENDING = "CREATE_VIRTUAL_ROOM_PENDING";
export const CREATE_VIRTUAL_ROOM_SUCCESS = "CREATE_VIRTUAL_ROOM_SUCCESS";
export const CREATE_VIRTUAL_ROOM_FAILURE = "CREATE_VIRTUAL_ROOM_FAILURE";
export const SHOW_INFOFORUPDATEMOBILENO_TOOLTIP = "SHOW_INFOFORUPDATEMOBILENO_TOOLTIP";